import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../../core/layout/Dialog';
import Button from '../../../../core/form/Button';
import NewDashboardImage from '../../../../core/images/new-dashboard.png';
import { Progress } from 'antd';
import { round } from 'lodash';
import moment from 'moment';

const MigrationDialog = (props) => (
  <Dialog
    width="50%"
    title="The new Dashboard!"
    onCancel={props.onClose}
    closeable={false}
    actions={
      !props.isMigrating && [
        ...(moment().isBefore(moment('2022-11-01')) ? [<Button onClick={props.onClose} key="close" label="No" />] : []),
        ...[
          <Button type="danger" icon="warning" onClick={props.onStart} key="onOk" label="Yes, start the migration" />,
        ],
      ]
    }
    isOpen={props.isOpen}
  >
    {!props.isMigrating && !props.isComplete && (
      <>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={NewDashboardImage} alt="new-dashboard" style={{ height: 300, margin: '0 auto' }} />
        </div>
        <br />
        <br />
        <p>
          <h3>Hi there. How is going?</h3>
          We have great news for you. We have created a new and updated dashboard and would like to invite you to join
          it.
        </p>
        <p>
          Flexge has grown and, growth always brings about some changes.
          <br />
          In this new dashboard, all schools and classes are now called groups. You can create any and as many groups as
          you want and assign them to your students. And don’t worry. All your current schools and classes will be
          automatically converted into groups once you’re in the new dashboard.
        </p>
        <p>
          You have until <b>October, 31</b> to migrate yourself. After that the migration will be mandatory
        </p>
        <p>
          Once you confirm the migration, we will move all your data to the new dashboard and your access must be
          through <a href="https://app.flexge.com">https://app.flexge.com</a>
        </p>
      </>
    )}
    {props.isMigrating && !props.isComplete && (
      <>
        <p>You migration is running, please wait a few minutes.</p>
        <Progress
          status={props.progress >= 100 ? 'success' : 'active'}
          percent={round(props.progress, 0)}
          width={500}
          showInfo
          strokeWidth={15}
        />
      </>
    )}
    {props.isComplete && (
      <>
        <p>Congratulations! you are now able to access the new dashboard</p>
        <p>
          You can access the new dashboard using the same email and password and the link to access it is{' '}
          <a href="https://app.flexge.com">https://app.flexge.com</a>.
        </p>
      </>
    )}
  </Dialog>
);

MigrationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onStart: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isMigrating: PropTypes.bool,
  isComplete: PropTypes.bool,
  progress: PropTypes.number,
};

MigrationDialog.defaultProps = {
  isOpen: false,
};

export default MigrationDialog;
